import { useQuery } from '@tanstack/react-query';
import api from '../services/api';
import { queryKeys } from '../lib/queryClient';
import { DashboardApiResponse } from '../types/dashboard.types';

// Dashboard API functions
const dashboardApi = {
  getOverview: async (): Promise<DashboardApiResponse> => {
    const response = await api.get<DashboardApiResponse>('/dashboard');
    // The interceptor already unwraps response.data, so response is the actual data
    return response as any;
  },
};

// Custom hooks
export const useDashboardOverview = () => {
  return useQuery({
    queryKey: queryKeys.dashboard.overview(),
    queryFn: dashboardApi.getOverview,
    staleTime: 0, // Always fetch fresh data
    refetchOnMount: true,
  });
};
